import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
var riskLabels = {
  1: '1 — Минимален',
  2: '2 — Нисък',
  3: '3 — Умерен',
  4: '4 — Среден',
  5: '5 — Повишен',
  6: '6 — Висок',
  7: '7 — Най-висок'
};
export var riskLevelsModel = function riskLevelsModel(response) {
  var _Object$keys;

  var arr = Object === null || Object === void 0 ? void 0 : (_Object$keys = Object.keys(response)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (key) {
    var _riskLabels$key;

    return {
      label: (_riskLabels$key = riskLabels[key]) !== null && _riskLabels$key !== void 0 ? _riskLabels$key : key,
      value: Number(key)
    };
  });
  return arr;
};